import React from 'react'
import { Link } from 'react-router-dom'
import './AdminNftEdit.css'

const AdminNftEdit = () => {
  return (
    <div className="admin-nft-edit">
      <Link>
        <button>메타마스크 연결</button>
      </Link>
    </div>
  )
}
export default AdminNftEdit
